import {Heading, HStack, VStack, Show} from 'platform/foundation';
import styled, {css} from 'styled-components';

import {ReactElement} from 'react';

import {Nullish, TestIdProps} from 'shared/web';

import {Flag, FlagProps} from '../Flag/Flag';

export interface CardContainerProps extends TestIdProps {
  heading: string;
  children?: ReactElement | ReactElement[];
  flag?: FlagProps | Nullish;
  isWithGradient?: boolean | Nullish;
  isOverflowHidden?: boolean | Nullish;
}

const CustomBox = styled.div<{
  isWithGradient?: boolean | Nullish;
  isOverflowHidden?: boolean | Nullish;
}>`
  position: relative;
  border-top-right-radius: ${({theme}) => theme.radii.medium};
  border-bottom-right-radius: ${({theme}) => theme.radii.medium};
  ${({isWithGradient}) =>
    isWithGradient &&
    css`
      background: linear-gradient(
        110deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 1) 75%,
        rgba(63, 196, 255, 0.175) 100%
      );
    `}
  ${({isOverflowHidden}) =>
    isOverflowHidden &&
    css`
      overflow: hidden;
    `}
`;

export function CardContainer(props: CardContainerProps) {
  return (
    <CustomBox isWithGradient={props.isWithGradient} isOverflowHidden={props.isOverflowHidden}>
      <VStack spacing={8}>
        <HStack align="center" spacing={4}>
          <Heading size={2}>{props.heading}</Heading>
          <Show when={props.flag}>
            <Flag {...props.flag} />
          </Show>
        </HStack>
        <VStack>{props.children}</VStack>
      </VStack>
    </CustomBox>
  );
}
